export const FETCH_DASHBOARD_TOKEN = 'FETCH_DASHBOARD_TOKEN';
export const FETCH_DASHBOARD_FAILED = 'FETCH_FAILED';
export const FETCH_DASHBOARD_SUCCEESS = 'FETCH_DASHBOARD_SUCCEESS';



// WEBPACK FOOTER //
// ./src/redux/actions/actionsTypes.js